export enum TodistusStatus {
  LUONNOS = 'LUONNOS',
  ODOTTAA_MAKSUA = 'ODOTTAA_MAKSUA',
  LUONNOS_HYLATTY = 'LUONNOS_HYLATTY',
  LUONNOS_VANHENTUNUT = 'LUONNOS_VANHENTUNUT',
  ODOTTAA_TODISTUSTEN_LUONTIA = 'ODOTTAA_TODISTUSTEN_LUONTIA',
  ODOTTAA_ASIAN_LUONTIA = 'ODOTTAA_ASIAN_LUONTIA',
  ALOITTAMATTA = 'ALOITTAMATTA', // AsiaStatus.ALOITTAMATTA
  KASITTELYSSA = 'KASITTELYSSA', // AsiaStatus.KASITTELYSSA
  HARKINTA_AIKA = 'HARKINTA_AIKA', // AsiaStatus.HARKINTA_AIKA
  ODOTTAA_LOPPUTOIMIA = 'ODOTTAA_LOPPUTOIMIA',
  VALMIS = 'VALMIS', // AsiaStatus.VALMIS (exception is electric VTJ-ote todistus orders, where asia is not created but VALMIS status is used while order is paid)
}
